import { SymbolUrlConstant } from 'src/constants';
import { SearchSymbolDto, SearchSymbolResponseDto } from 'src/dtos';
import { WithAuthToken, httpRequest } from 'src/utils';

export class SymbolApi {
  async search({ queryParams, authToken }: WithAuthToken<SearchSymbolDto>): Promise<SearchSymbolResponseDto> {
    return httpRequest<SearchSymbolResponseDto>({
      method: 'GET',
      url: SymbolUrlConstant.SEARCH,
      queryParams,
      authToken,
    });
  }
}
